<template>
    <div v-if="open" id="uesrtext">
        <div style="display: flex;">
            <el-popover placement="top-start" width="400" trigger="click" class="emoBox">
                <div class="emotionList">
                    <a
                        href="javascript:void(0);"
                        @click="getEmo(item)"
                        v-for="(item, index) in faceList"
                        :key="index"
                        class="emotionItem"
                        ><el-image mode="widthFix" :src="getImageSrc(item.url)"></el-image></a
                    >
                </div>
                <el-button id="emojiBtn" class="emotionSelect" slot="reference">
                    <i style="font-size: 24px;" class="fa fa-smile-o" aria-hidden="true"></i>
                </el-button>
            </el-popover>
            <!-- <el-upload
                class="upload-btn"
                action="/file"
                :before-upload="beforeAvatarUpload"
                :on-success="imgSuccess"
                :on-error="imgError"
                :show-file-list="false"
                accept=".jpg,.jpeg,.png,.JPG,JPEG,.PNG,.gif,.GIF"
            >
                <el-button id="uploadImgBtn" icon="el-icon-picture-outline"></el-button>
            </el-upload> -->
            <el-upload :action="action" :headers="header" :before-upload="beforeAvatarUpload"
                class="upload-btn" accept=".jpg,.jpeg,.png,.JPG,JPEG,.PNG,.gif,.GIF" :show-file-list="false"
                :http-request="uploadImage">
                <el-button id="uploadImgBtn" style="font-size: 24px;" icon="el-icon-picture-outline"></el-button>
              </el-upload>
        </div>
        <textarea id="textarea" :placeholder="`按 ${models} 发送`" v-model="content" @keydown="addMessage"> </textarea>
        <el-dropdown id="sendBtn" split-button type="primary" @command="handleCommand" @click="addMessageByClick">
            发送(S)
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="Enter">Enter发送</el-dropdown-item>
                <el-dropdown-item command="Ctrl+Enter">Ctrl+Enter发送</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button-group> -->
            <!-- <el-button id="sendBtn" type="primary" size="mini" @click="addMessageByClick">发送(S)</el-button> -->
        <!-- </el-button-group> -->
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { get, upload } from '@/utils/request'; 
import socketObj from '@/utils/socket/socket_methods.js'
// const appData = require('../../../utils/emoji.json'); //引入存放emoji表情的json文件
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH } from '@/utils/constant.js';
import { validateMessageLength } from '@/utils/security.js';
export default {
    name: 'uesrtext',
    data() {
        return {
            faceList: [  //表情包数据
                {
                    "url": "100.gif",
                    alt: "face[微笑]"
                }, {
                    "url": "101.gif",
                    alt: "face[伤心]"
                }, {
                    "url": "102.gif",
                    alt: "face[美女]"
                }, {
                    "url": "103.gif",
                    alt: "face[发呆]"
                }, {
                    "url": "104.gif",
                    alt: "face[墨镜]"
                }, {
                    "url": "105.gif",
                    alt: "face[哭]"
                }, {
                    "url": "106.gif",
                    alt: "face[羞]"
                }, {
                    "url": "107.gif",
                    alt: "face[哑]"
                }, {
                    "url": "108.gif",
                    alt: "face[睡]"
                }, {
                    "url": "109.gif",
                    alt: "face[哭]"
                }, {
                    "url": "110.gif",
                    alt: "face[囧]"
                }, {
                    "url": "111.gif",
                    alt: "face[怒]"
                }, {
                    "url": "112.gif",
                    alt: "face[调皮]"
                }, {
                    "url": "113.gif",
                    alt: "face[笑]"
                }, {
                    "url": "114.gif",
                    alt: "face[惊讶]"
                }, {
                    "url": "115.gif",
                    alt: "face[难过]"
                }, {
                    "url": "116.gif",
                    alt: "face[酷]"
                }, {
                    "url": "117.gif",
                    alt: "face[汗]"
                }, {
                    "url": "118.gif",
                    alt: "face[抓狂]"
                }, {
                    "url": "119.gif",
                    alt: "face[吐]"
                }, {
                    "url": "120.gif",
                    alt: "face[笑]"
                }, {
                    "url": "121.gif",
                    alt: "face[快乐]"
                }, {
                    "url": "122.gif",
                    alt: "face[奇]"
                }, {
                    "url": "123.gif",
                    alt: "face[傲]"
                },
                {
                    "url": "124.gif",
                    alt: "face[饿]"
                }, {
                    "url": "125.gif",
                    alt: "face[累]"
                }, {
                    "url": "126.gif",
                    alt: "face[吓]"
                }, {
                    "url": "127.gif",
                    alt: "face[汗]"
                }, {
                    "url": "128.gif",
                    alt: "face[高兴]"
                }, {
                    "url": "129.gif",
                    alt: "face[闲]"
                }, {
                    "url": "130.gif",
                    alt: "face[努力]"
                }, {
                    "url": "131.gif",
                    alt: "face[骂]"
                }, {
                    "url": "132.gif",
                    alt: "face[疑问]"
                }, {
                    "url": "133.gif",
                    alt: "face[秘密]"
                }, {
                    "url": "134.gif",
                    alt: "face[乱]"
                }, {
                    "url": "135.gif",
                    alt: "face[疯]"
                }, {
                    "url": "136.gif",
                    alt: "face[哀]"
                }, {
                    "url": "137.gif",
                    alt: "face[鬼]"
                }, {
                    "url": "138.gif",
                    alt: "face[打击]"
                }, {
                    "url": "139.gif",
                    alt: "face[bye]"
                }, {
                    "url": "140.gif",
                    alt: "face[汗]"
                }, {
                    "url": "141.gif",
                    alt: "face[抠]"
                }, {
                    "url": "142.gif",
                    alt: "face[鼓掌]"
                }, {
                    "url": "143.gif",
                    alt: "face[糟糕]"
                }, {
                    "url": "144.gif",
                    alt: "face[恶搞]"
                }, {
                    "url": "145.gif",
                    alt: "face[什么]"
                }, {
                    "url": "146.gif",
                    alt: "face[什么]"
                }, {
                    "url": "147.gif",
                    alt: "face[累]"
                },
                {
                    "url": "148.gif",
                    alt: "face[看]"
                }, {
                    "url": "149.gif",
                    alt: "face[难过]"
                }, {
                    "url": "150.gif",
                    alt: "face[难过]"
                }, {
                    "url": "151.gif",
                    alt: "face[坏]"
                }, {
                    "url": "152.gif",
                    alt: "face[亲]"
                }, {
                    "url": "153.gif",
                    alt: "face[吓]"
                }, {
                    "url": "154.gif",
                    alt: "face[可怜]"
                }, {
                    "url": "155.gif",
                    alt: "face[刀]"
                }, {
                    "url": "156.gif",
                    alt: "face[水果]"
                }, {
                    "url": "157.gif",
                    alt: "face[酒]"
                }, {
                    "url": "158.gif",
                    alt: "face[篮球]"
                }, {
                    "url": "159.gif",
                    alt: "face[乒乓]"
                }, {
                    "url": "160.gif",
                    alt: "face[咖啡]"
                }, {
                    "url": "161.gif",
                    alt: "face[美食]"
                }, {
                    "url": "162.gif",
                    alt: "face[动物]"
                }, {
                    "url": "163.gif",
                    alt: "face[鲜花]"
                }, {
                    "url": "164.gif",
                    alt: "face[枯]"
                }, {
                    "url": "165.gif",
                    alt: "face[唇]"
                }, {
                    "url": "166.gif",
                    alt: "face[爱]"
                }, {
                    "url": "167.gif",
                    alt: "face[分手]"
                }, {
                    "url": "168.gif",
                    alt: "face[生日]"
                }, {
                    "url": "169.gif",
                    alt: "face[电]"
                }, {
                    "url": "170.gif",
                    alt: "face[炸弹]"
                }, {
                    "url": "171.gif",
                    alt: "face[刀子]"
                },
                {
                    "url": "172.gif",
                    alt: "face[足球]"
                }, {
                    "url": "173.gif",
                    alt: "face[瓢虫]"
                }, {
                    "url": "174.gif",
                    alt: "face[翔]"
                }, {
                    "url": "175.gif",
                    alt: "face[月亮]"
                }, {
                    "url": "176.gif",
                    alt: "face[太阳]"
                }, {
                    "url": "177.gif",
                    alt: "face[礼物]"
                }, {
                    "url": "178.gif",
                    alt: "face[抱抱]"
                }, {
                    "url": "179.gif",
                    alt: "face[拇指]"
                }, {
                    "url": "180.gif",
                    alt: "face[贬低]"
                }, {
                    "url": "181.gif",
                    alt: "face[握手]"
                }, {
                    "url": "182.gif",
                    alt: "face[剪刀手]"
                }, {
                    "url": "183.gif",
                    alt: "face[抱拳]"
                }, {
                    "url": "184.gif",
                    alt: "face[勾引]"
                }, {
                    "url": "185.gif",
                    alt: "face[拳头]"
                }, {
                    "url": "186.gif",
                    alt: "face[小拇指]"
                }, {
                    "url": "187.gif",
                    alt: "face[拇指八]"
                }, {
                    "url": "188.gif",
                    alt: "face[食指]"
                }, {
                    "url": "189.gif",
                    alt: "face[ok]"
                }, {
                    "url": "190.gif",
                    alt: "face[情侣]"
                }, {
                    "url": "191.gif",
                    alt: "face[爱心]"
                }, {
                    "url": "192.gif",
                    alt: "face[蹦哒]"
                }, {
                    "url": "193.gif",
                    alt: "face[颤抖]"
                }, {
                    "url": "194.gif",
                    alt: "face[怄气]"
                }, {
                    "url": "195.gif",
                    alt: "face[跳舞]"
                },
                {
                    "url": "196.gif",
                    alt: "face[发呆]"
                }, {
                    "url": "197.gif",
                    alt: "face[背着]"
                }, {
                    "url": "198.gif",
                    alt: "face[伸手]"
                }, {
                    "url": "199.gif",
                    alt: "face[耍帅]"
                }, {
                    "url": "200.png",
                    alt: "face[微笑]"
                }, {
                    "url": "201.png",
                    alt: "face[生病]"
                }, {
                    "url": "202.png",
                    alt: "face[哭泣]"
                }, {
                    "url": "203.png",
                    alt: "face[吐舌]"
                }, {
                    "url": "204.png",
                    alt: "face[迷糊]"
                }, {
                    "url": "205.png",
                    alt: "face[瞪眼]"
                }, {
                    "url": "206.png",
                    alt: "face[恐怖]"
                }, {
                    "url": "207.png",
                    alt: "face[忧愁]"
                }, {
                    "url": "208.png",
                    alt: "face[眨眉]"
                }, {
                    "url": "209.png",
                    alt: "face[闭眼]"
                }, {
                    "url": "210.png",
                    alt: "face[鄙视]"
                }, {
                    "url": "211.png",
                    alt: "face[阴暗]"
                }, {
                    "url": "212.png",
                    alt: "face[小鬼]"
                }, {
                    "url": "213.png",
                    alt: "face[礼物]"
                }, {
                    "url": "214.png",
                    alt: "face[拜佛]"
                }, {
                    "url": "215.png",
                    alt: "face[力量]"
                }, {
                    "url": "216.png",
                    alt: "face[金钱]"
                }, {
                    "url": "217.png",
                    alt: "face[蛋糕]"
                }, {
                    "url": "218.png",
                    alt: "face[彩带]"
                }, {
                    "url": "219.png",
                    alt: "face[礼物]"
                }, 
			],
            content: '',
            models: 'Enter',
            messageId:'',
            open:false,
            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            msgurl:'',
        };
    },
    // computed: { ...mapState('chat', ['sessions', 'currentSession', 'currentUser']) },
    computed: {...mapState('newChat',['userInfo','chatUserInfo','socketTask']),
        Mute(){
            // console.log(this.$store.state.newChat.Mute);
            return this.$store.state.newChat.Mute;
        },
        loggedIn(){
            // console.log(this.$store.state.newChat.loggedIn);
            return this.$store.state.newChat.loggedIn;
        },
        isNetworkError(){
            // console.log(this.$store.state.newChat.isNetworkError);
            return this.$store.state.newChat.isNetworkError;
        }
    },

    mounted() {
        // for (let i in appData) {
        //     //读取json文件保存数据给数组
        //     this.faceList.push(appData[i].char);
        // }
        // console.log(this.currentUser, this.currentSession);
        // console.log(this.userInfo,this.chatUserInfo)
    },
    watch:{
        chatUserInfo(){
            if(this.chatUserInfo.senderId){
                this.open = true
            }else{
                this.open = false
            }
        }
    },
    methods: {
        getImageSrc(url) {
            return require(`@/assets/img/emoji/${url}`);
        },
        handleCommand(val){
            // console.log(val);
            this.models = val;
        },
        addMessageByClick() {
            if(this.content == ''){
                return
            }
            // 验证消息长度
            if(!validateMessageLength(this.content)){
                this.$message.error('消息内容过长，最多5000个字符');
                return
            }
            if(this.loggedIn || this.isNetworkError){
                get(`/mpp/utils/getMessageId`).then((res)=>{
                    let obj = {
                        senderId: this.userInfo.id,
                        isSend: 3,
                        messageContent: this.content,
                        messageId: res.messageId,
                        messageType: 1,
                        createTime: new Date().getTime(),
                        receiverId: this.chatUserInfo.senderId
                    }
                    this.$store.dispatch('newChat/notOnLine',obj)
                    this.content = ''
                })
                return
            }
            // 尝试代码
            // let id = await get(`/mpp/utils/getMessageId`)
            // console.log(id.messageId)
            get(`/mpp/utils/getMessageId`).then((res)=>{
                if(res.success){
                    this.messageId = res.messageId
                    // // 使用正则表达式匹配特殊字符（表情符号）
                    // let specialCharRegex = /(?:\[([^\]]+)\])|(?:&#(\d+);)/g;

                    // // 替换特殊字符为HTML实体编码
                    // let encodedText = this.content.replace(specialCharRegex, (match, p1, p2) => {
                    //     if (p1) {
                    //         return p1.split('').map(char => `&#${char.charCodeAt(0)};`).join('');
                    //     } else if (p2) {
                    //         return `&#${p2};`;
                    //     }
                    // });
                    // 替换消息中的表情符号为图片地址
                    let processedMessage = this.content;
                    // this.faceList.forEach(emoji => {
                        // let str = emoji.alt
                        // let result = str.replace(/\[/g, ''); // 使用正则表达式匹配方括号及其内容，替换为空字符串
                        // result = result.replace(/\]/g, ''); // 使用正则表达式匹配方括号及其内容，替换为空字符串
                        // console.log(result)
                        // let altPattern = new RegExp(emoji.alt.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
                        // console.log(altPattern,emoji,processedMessage.replace(altPattern, `<img src="${emoji.url}" alt="${result}">`))
                        // processedMessage = processedMessage.replace(altPattern, `<img style="display: inline-block;width: 20px;height: 20px;" class="custom-img" src="${this.getImageSrc(emoji.url)}" alt="${result}">`);
                    // });
                    let obj = {
                        senderId: this.userInfo.id,
                        receiverId: this.chatUserInfo.senderId,
                        message: processedMessage,
                        messageId: res.messageId
                    }
                    // console.log(processedMessage)
                    // return

                    let msgobj = socketObj.privateChat(obj)
                    if(!this.socketTask){
                        // this.$message.error('已掉线')
                        this.content = '';
                        return
                    }
                    this.socketTask.send(msgobj)
                    // console.log(msgobj)
                    this.$store.dispatch('newChat/setChatListsss',JSON.parse(msgobj))
                    //清空输入框
                    this.content = '';
                }
            })


            // 前人所写
            // let msgObj = new Object();
            // msgObj.content = this.content;
            // msgObj.messageTypeId = 1;
            // //发送群聊消息
            // if (this.currentSession.username == '群聊') {
            //     console.log(this.content);
            //     this.$store.state.stomp.send('/ws/groupChat', {}, JSON.stringify(msgObj));
            // }
            // //给机器人发送消息
            // if (this.currentSession.username == '机器人') {
            //     msgObj.fromNickname = this.$store.state.currentUser.nickname;
            //     msgObj.to = '机器人';
            //     this.$store.state.stomp.send('/ws/robotChat', {}, JSON.stringify(msgObj));
            //     //保存该条记录到session
            //     this.$store.commit('addMessage', msgObj);
            // }
            // //发送私聊消息
            // else {
            //     console.log(231312313);
            //     // console.log(this.$store.state.chat.currentSession.nickname);
            //     // console.log(this.$store.state.chat.currentUser);
            //     msgObj.from = this.$store.state.chat.currentUser.username;
            //     msgObj.fromNickname = this.$store.state.chat.currentUser.nickname;
            //     msgObj.to = this.currentSession.username;

            //     // this.$store.state.chat.stomp.send('/ws/chat', {}, JSON.stringify(msgObj));
            //     //提交私聊消息记录
            //     console.log(JSON.stringify(msgObj));
            //     this.$store.commit('chat/addMessage', msgObj);
            // }
            // //清空输入框
            // this.content = '';
        },
        // 小徐写
        getId(){
            get(`/mpp/utils/getMessageId`).then((res)=>{
                if(res.success){
                    this.messageId = res.messageId
                }
            })
        },
        addMessage(e) {
            if(this.models == 'Enter'){
                if (e.ctrlKey && e.keyCode === 13) {
                    e.preventDefault();
                    this.content = this.content + '\n';
                }else if (e.keyCode === 13){
                    e.preventDefault();
                    // console.log("我进来了")
                    this.addMessageByClick();
                }
            }else if(this.models == 'Ctrl+Enter'){
                if (e.ctrlKey && e.keyCode === 13) {
                    // console.log("我进来了")
                    this.addMessageByClick();
                }
            }
        },
        /**
         *       图片上传的方法
         */
        //上传前
        beforeAvatarUpload(file) {
            //不给机器人发送图片
            // if (this.currentSession.username == '机器人') {
            //     this.$message.error('瓦力拒绝接收你的图片！');
            // }
            //判断图片大小
            let isLt1M = file.size / 1024 / 1024 < 10;
            // console.log(file);
            if (!isLt1M) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            //判断图片的格式
            let imgType = file.name.substring(file.name.lastIndexOf('.') + 1);
            imgType = imgType.toLowerCase();
            let isImg = imgType === 'jpg' || imgType === 'png' || imgType === 'jpeg' || imgType === 'gif';
            if (!isImg) {
                this.$message.error('上传图片格式不符合要求！');
            }
            return isLt1M && isImg;
        },
        uploadImage(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    let x = res.url
                    if(this.loggedIn){
                        get(`/mpp/utils/getMessageId`).then((res)=>{
                            let obj = {
                                senderId: this.userInfo.id,
                                isSend: 3,
                                messageContent: x,
                                messageId: res.messageId,
                                messageType: 2,
                                createTime: new Date().getTime(),
                                receiverId: this.chatUserInfo.senderId
                            }
                            this.$store.dispatch('newChat/notOnLine',obj)
                        })
                        return
                    } 
                    get(`/mpp/utils/getMessageId`).then((res)=>{
                        if(res.success){
                            this.messageId = res.messageId
                            let obj = {
                                senderId: this.userInfo.id,
                                receiverId: this.chatUserInfo.senderId,
                                message: x,
                                messageId: res.messageId
                            }
                            // console.log(this.content)
                            let msgobj = socketObj.packImageMessage(obj)
                            if(!this.socketTask){
                                this.$message.error('已掉线')
                                this.content = '';
                                return
                            }
                            this.socketTask.send(msgobj)
                            // console.log(msgobj)
                            this.$store.dispatch('newChat/setChatListsss',JSON.parse(msgobj))
                            //清空输入框
                            // this.content = '';
                        }
                    })
                }
            });
        },
        // 图片上传成功
        imgSuccess(response, file, fileList) {
            console.log('图片url为：' + response);
            let msgObj = new Object();
            msgObj.content = response;
            //设置消息类型为图片
            msgObj.messageTypeId = 2;
            if (this.currentSession.username == '群聊') {
                this.$store.state.chat.stomp.send('/ws/groupChat', {}, JSON.stringify(msgObj));
            } else {
                msgObj.from = this.$store.state.chat.currentUser.username;
                msgObj.fromNickname = this.$store.state.chat.currentUser.nickname;
                msgObj.to = this.currentSession.username;
                this.$store.state.chat.stomp.send('/ws/chat', {}, JSON.stringify(msgObj));
                //提交私聊消息记录
                this.$store.commit('chat/addMessage', msgObj);
            }
        },
        // 图片上传失败
        imgError(err, file, fileList) {
            this.$message.error('上传失败');
        },
        //获取Emoji
        getEmo(item) {
            var textArea = document.getElementById('textarea');
            //将选中的表情插入到输入文本的光标之后
            function changeSelectedText(obj, str) {
                if (window.getSelection) {
                    // 非IE浏览器
                    textArea.setRangeText(str.alt);
                    // 在未选中文本的情况下，重新设置光标位置
                    textArea.selectionStart += str.alt.length;
                    textArea.focus();
                } else if (document.selection) {
                    // IE浏览器
                    obj.focus();
                    var sel = document.selection.createRange();
                    sel.text = str.alt;
                }
            }
            // console.log(this.faceList[index])
            changeSelectedText(textArea, item);
            this.content = textArea.value; // 要同步data中的数据
            // console.log(this.faceList[index]);
            return;
        }
    }
};
</script>

<style lang="scss">
/* el-popover是和app同级的，所以scoped的局部属性设置无效 */
/* 需要设置全局style */
.el-popover {
    height: 200px;
    width: 450px;
    overflow: scroll;
    overflow-x: auto;
}
</style>

<style lang="scss" scoped>
#uesrtext {
    // position: absolute;
    // bottom: 0;
    // right: 0;
    width: 100%;
    // height: 30%;
    height: 181px;
    border: solid 1px #ddd;
    background-color: white;
    > textarea {
        padding: 10px;
        width: 95%;
        height: 52%;
        border: none;
        outline: none;
        resize: none; //禁止拉伸
    }
    #sendBtn {
        float: right;
        margin-right: 14px;
    }
    #uploadImgBtn {
        border: none;
        padding-bottom: 0px;
        margin-bottom: 0px;
        padding-left: 12px;
    }
    #uploadImgBtn:hover {
        background-color: white;
    }
    #emojiBtn {
        border: none;
        padding-right: 0px;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }
    #emojiBtn:hover {
        background-color: white;
    }
    .upload-btn {
        display: inline-block;
        width: 32px;
        height: 28px;
    }
}

::v-deep .el-upload {
    width: 38px;
    height: 36px;
    // padding-top: 5px;
    border: none;
}
.emotionList {
    display: flex;
    flex-wrap: wrap;
    padding: 5px;
    width: 100%;
    height: 100%;
}
.emotionItem {
    width: 10%;
    font-size: 20px;
    text-align: center;
}
/*包含以下四种的链接*/
.emotionItem {
    text-decoration: none;
}
/*正常的未被访问过的链接*/
.emotionItem:link {
    text-decoration: none;
}
/*已经访问过的链接*/
.emotionItem:visited {
    text-decoration: none;
}
/*鼠标划过(停留)的链接*/
.emotionItem:hover {
    text-decoration: none;
}
/* 正在点击的链接*/
.emotionItem:active {
    text-decoration: none;
}
</style>
